// Pathify
import { make } from "vuex-pathify";

// Data
const state = {
  categories: [
    {
      name: "Icon",
      styleItems: ["Material Design", "3D"],
    },
    {
      name: "Image",
      styleItems: ["Illustration"],
    },
  ],
  backgroundColorItems: ["Transparency", "White", "Grey"],
};

const mutations = make.mutations(state);

const getters = make.getters(state);

const actions = make.actions(state);

function resetState() {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,

  resetState,
};
